import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import HeroSection from "@/pages/home/components/HeroSection";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import FeedSection from "@/pages/home/components/FeedSection";
import SpotlightSection from "@/pages/home/components/SpotlightSection";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandSection from "@/pages/home/components/BrandSection";
import { articles, faqs } from "@/mocks/news";

const BASE_URL = "https://jugxooi.cn";

export default function Home() {
  const featured = articles.find((article) => article.featured) ?? articles[0];
  const homeFaqs = faqs.slice(0, 4);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "美日吃瓜",
      url: BASE_URL,
      description:
        "聚焦娱乐圈热点与幕后故事的简体中文资讯频道，覆盖偶像塌房、演员绯闻、歌手翻车与综艺名场面。",
      email: "hello@meirichigua.com",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "美日吃瓜 - 娱乐圈偶像塌房与演员绯闻每日速递",
      url: `${BASE_URL}/`,
      inLanguage: "zh-CN",
      description:
        "美日吃瓜娱乐圈频道，聚焦明星八卦与偶像塌房现场。演员绯闻、歌手翻车、综艺名场面一网打尽，每日更新娱乐圈最新抓马事件。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日热门娱乐内容",
      itemListElement: articles.slice(0, 8).map((article, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: article.title,
        url: `${BASE_URL}/article/${article.id}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: homeFaqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="美日吃瓜 - 娱乐圈偶像塌房与演员绯闻每日速递"
        description="美日吃瓜娱乐圈频道，聚焦明星八卦与偶像塌房现场。演员绯闻、歌手翻车、综艺名场面一网打尽，每日更新娱乐圈最新抓马事件，满足你对明星幕后真相的好奇心。"
        keywords="美日吃瓜,美日吃瓜娱乐圈,美日吃瓜偶像塌房,美日吃瓜演员绯闻,美日吃瓜歌手翻车,美日吃瓜综艺名场面"
        canonical="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection featured={featured} />
        <CategoryStrip />
        <FeedSection />
        <SpotlightSection />
        <FaqSection />
        <BrandSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}